import {
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";

@observer
export default class EmpresaParauapebas extends React.Component<{}, {}> {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <MDBCol>

          <div style={{ width: 1000 }}>

            <FormGroup
              label="Senha Prefeitura"
              labelFor="senha"
              style={{ width: "49%" }}
            >
              <InputGroup
                autoComplete="password-parauapebas"
                name="password-parauapebas"
                type="text"
                id="nome-fantasia-off"
                defaultValue={EmpresaStore.obs.empresa_edit.senha_parauapebas}
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_parauapebas = e.target.value}
              />
            </FormGroup>

          </div>

        </MDBCol>

      </>
    );
  }
}
